/**
 * 题库题型配置（与后端 questionType 一致）
 * type：字符串 '1'～'14'；label：展示名
 * 答题区四类由下方 kindFromTypeCode 按 type 映射，不依赖表字段
 */
export const QUESTION_TYPE_OPTIONS = [
    { label: '单选题', type: '1' },
    { label: '多选题', type: '2' },
    { label: '判断题', type: '3' },
    { label: '填空题', type: '4' },
    { label: '名词解释', type: '5' },
    { label: '论述题', type: '6' },
    { label: '简答题', type: '7' },
    { label: '病案分析题', type: '8' },
    { label: '经义阐释题', type: '9' },
    { label: '病案单选题', type: '10' },
    // 10以上调整完，以下带确定
    { label: '多选K型题', type: '11' },//单选
    { label: '组合选择题', type: '12' },//测过
    { label: '分析题', type: '13' },//测过
    { label: '病案分析选择题', type: '14' },//测过
];

const SINGLE_TYPES = new Set(['1', '3', '10']);
const MULTIPLE_TYPES = new Set(['2', '11', '12']);
const ESSAY_TYPES = new Set(['5', '6', '7', '8', '9', '13']);

/** 仅根据题型编码得到答题区四类 */
function kindFromTypeCode(typeCode) {
    if (!typeCode) return 'single';
    const t = String(typeCode);
    if (MULTIPLE_TYPES.has(t)) return 'multiple';
    if (t === '4') return 'fill';
    if (ESSAY_TYPES.has(t)) return 'essay';
    if (SINGLE_TYPES.has(t)) return 'single';
    return 'single';
}

function getQuestionTypeCode(row, typeOptions = QUESTION_TYPE_OPTIONS) {
    const val =
        row.questionType != null && row.questionType !== '' ? row.questionType : row.type;
    if (val !== undefined && val !== null && val !== '') {
        return String(val);
    }
    const name = String(row.typeName || '').trim();
    if (!name) return '';
    const byLabel = typeOptions.find((opt) => opt.label === name);
    return byLabel ? String(byLabel.type) : '';
}

function kindFromItem(item, typeOptions = QUESTION_TYPE_OPTIONS) {
    return kindFromTypeCode(getQuestionTypeCode(item, typeOptions));
}

export function getQuestionTypeLabel(row, typeOptions = QUESTION_TYPE_OPTIONS) {
    const val =
        row.questionType != null && row.questionType !== ''
            ? row.questionType
            : row.type;
    if (val === undefined || val === null || val === '') {
        return row.typeName || '';
    }
    const found = typeOptions.find((opt) => String(opt.type) === String(val));
    return found ? found.label : row.typeName || '';
}
 
export function blankCountFor(item) {
    const n = Number(item.blankCount) || 0;
    if (n > 1) return n;
    const arr = item.fillAnswers;
    if (Array.isArray(arr) && arr.length > 1) return arr.length;
    return 1;
}

/** 仅按 questionType / type（及 typeName 反查）判断逻辑题型 */
export function questionKind(item) {
    return kindFromItem(item);
}

function normalizeOptions(options) {
    if (!options || !options.length) return [];
    const keys = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    return options.map((o, i) => {
        if (typeof o === 'string') {
            const k = keys[i] || String(i + 1);
            return { key: k, text: o, value: k };
        }
        const k = o.key || o.label || keys[i];
        return {
            ...o,
            key: k,
            text: o.text != null ? o.text : o.content,
            value: o.value != null ? o.value : k,
        };
    });
}
  

function normalizeAnswerKey(str) {
    if (str == null || str === '') return '';
    return String(str)
        .split(/[,，]/)
        .map((s) => s.trim())
        .filter(Boolean)
        .sort()
        .join(',');
}
